/* NexHome Theme JS — v1.0 */
(function () {
  'use strict';

  var NexHome = window.NexHome = {};

  /* ── UTILS ────────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ── CURSOR ───────────────────────────────────────────── */
  function initCursor() {
    var dot  = qs('.cursor');
    var ring = qs('.cursor-ring');
    if (!dot || !ring) return;
    var rx = 0, ry = 0;
    document.addEventListener('mousemove', function (e) {
      dot.style.left  = e.clientX + 'px';
      dot.style.top   = e.clientY + 'px';
      rx += (e.clientX - rx) * 0.12;
      ry += (e.clientY - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
    });
    requestAnimationFrame(function loop() {
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(loop);
    });
  }

  /* ── HAMBURGER / MOBILE MENU ──────────────────────────── */
  function initMobileMenu() {
    var btn  = qs('.hamburger');
    var menu = qs('.mobile-menu');
    var close = qs('.mm-close');
    if (!btn || !menu) return;
    function open() {
      btn.classList.add('open');
      menu.classList.add('open');
      document.body.classList.add('menu-open');
      document.body.style.overflow = 'hidden';
    }
    function close_() {
      btn.classList.remove('open');
      menu.classList.remove('open');
      document.body.classList.remove('menu-open');
      document.body.style.overflow = '';
    }
    window.closeMenu = close_;
    on(btn, 'click', open);
    on(close, 'click', close_);
    on(menu, 'click', function (e) {
      if (e.target === menu) close_();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close_();
    });
  }

  /* ── SEARCH MODAL ─────────────────────────────────────── */
  function initSearch() {
    var overlay = qs('.search-modal-overlay');
    var closeBtn = qs('.search-modal-close');
    qsa('[data-search-open]').forEach(function (btn) {
      on(btn, 'click', function () {
        if (overlay) {
          overlay.classList.add('open');
          var inp = overlay.querySelector('input');
          if (inp) inp.focus();
        }
      });
    });
    on(closeBtn, 'click', function () { if (overlay) overlay.classList.remove('open'); });
    on(overlay, 'click', function (e) { if (e.target === overlay) overlay.classList.remove('open'); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay) overlay.classList.remove('open');
    });
  }

  /* ── ACCORDION (product page, collapsible content) ───── */
  function initAccordions() {
    qsa('.acc-head').forEach(function (head) {
      on(head, 'click', function () {
        var body = head.nextElementSibling;
        if (!body || !body.classList.contains('acc-body')) return;
        var isOpen = head.classList.contains('open');
        head.classList.toggle('open', !isOpen);
        body.classList.toggle('open', !isOpen);
        head.setAttribute('aria-expanded', !isOpen);
      });
    });
  }

  /* ── FAQ ACCORDION ────────────────────────────────────── */
  function initFaq() {
    qsa('.faq-item').forEach(function (item) {
      var q = item.querySelector('.faq-q');
      on(q || item, 'click', function () {
        item.classList.toggle('open');
      });
    });
  }

  /* ── TABS ─────────────────────────────────────────────── */
  function initTabs() {
    qsa('.tab-btn').forEach(function (btn) {
      on(btn, 'click', function () {
        var target = btn.dataset.tab;
        var container = btn.closest('[data-tabs-container]') || btn.closest('.tab-collage-section') || document;
        qsa('.tab-btn', container).forEach(function (b) { b.classList.remove('active'); });
        qsa('.tab-panel', container).forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = qs('[data-tab-panel="' + target + '"]', container);
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* ── ARTWORK CARD THUMBNAIL SWITCHER ─────────────────── */
  window.switchArtCard = function (btn, cardId) {
    var card = document.getElementById(cardId);
    if (!card) return;
    var img  = card.querySelector('.art-main-img');
    var tag  = card.querySelector('.art-tag-live');
    if (img) {
      img.style.opacity = '0';
      img.src = btn.dataset.img;
      img.onload = function () { img.style.opacity = '1'; };
    }
    if (tag) {
      tag.href = btn.dataset.url || '#';
      var n = tag.querySelector('.art-tag-name');
      var s = tag.querySelector('.art-tag-sub');
      var p = tag.querySelector('.art-tag-price');
      if (n) n.textContent = btn.dataset.title || '';
      if (s) s.textContent = btn.dataset.sub   || '';
      if (p) p.textContent = btn.dataset.price  || '';
    }
    var outer = btn.closest('.art-thumbs-outer');
    if (outer) outer.querySelectorAll('.art-thumb').forEach(function (t) { t.classList.remove('active'); });
    btn.classList.add('active');
  };

  /* ── SLIDESHOW ────────────────────────────────────────── */
  function initSlideshow() {
    qsa('.hero.slideshow[data-autoplay]').forEach(function (hero) {
      var slides = qsa('.slide', hero);
      var dots   = qsa('.slide-dot', hero);
      var btnPrev = qs('.slide-btn.slide-prev', hero);
      var btnNext = qs('.slide-btn.slide-next', hero);
      if (slides.length < 2) return;
      var current = 0;
      var speed = parseInt(hero.dataset.speed, 10) || 5000;
      function goTo(i) {
        slides[current].classList.remove('active');
        if (dots[current]) dots[current].classList.remove('active');
        current = (i + slides.length) % slides.length;
        slides[current].classList.add('active');
        if (dots[current]) dots[current].classList.add('active');
      }
      var timer = setInterval(function () { goTo(current + 1); }, speed);
      function resetTimer() {
        clearInterval(timer);
        timer = setInterval(function () { goTo(current + 1); }, speed);
      }
      dots.forEach(function (dot, i) {
        on(dot, 'click', function () { goTo(i); resetTimer(); });
      });
      on(btnPrev, 'click', function () { goTo(current - 1); resetTimer(); });
      on(btnNext, 'click', function () { goTo(current + 1); resetTimer(); });
    });
  }

  /* ── COUNTDOWN TIMER ──────────────────────────────────── */
  function initCountdowns() {
    qsa('[data-countdown]').forEach(function (el) {
      var endStr = el.dataset.end || el.dataset.countdown;
      if (!endStr) return;
      var end = new Date(endStr).getTime();
      var units = {
        d: el.querySelector('[data-days]'),
        h: el.querySelector('[data-hours]'),
        m: el.querySelector('[data-minutes]'),
        s: el.querySelector('[data-seconds]')
      };
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          Object.values(units).forEach(function (u) { if (u) u.textContent = '00'; });
          return;
        }
        var days  = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins  = Math.floor((diff % 3600000) / 60000);
        var secs  = Math.floor((diff % 60000) / 1000);
        function fmt(n) { return n < 10 ? '0' + n : n; }
        if (units.d) units.d.textContent = fmt(days);
        if (units.h) units.h.textContent = fmt(hours);
        if (units.m) units.m.textContent = fmt(mins);
        if (units.s) units.s.textContent = fmt(secs);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ── RECENTLY VIEWED ──────────────────────────────────── */
  NexHome.trackProductView = function (id, title, url, price, image) {
    try {
      var KEY = 'nex_recently_viewed';
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      list = list.filter(function (p) { return p.id !== id; });
      list.unshift({ id: id, title: title, url: url, price: price, image: image });
      list = list.slice(0, 8);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  };

  function renderRecentlyViewed() {
    var grids = qsa('[data-recently-viewed-grid]');
    if (!grids.length) return;
    try {
      var list = JSON.parse(localStorage.getItem('nex_recently_viewed') || '[]');
      grids.forEach(function (grid) {
        var section = grid.closest('.recently-viewed') || grid.closest('section');
        if (!list.length) {
          if (section) section.style.display = 'none';
          return;
        }
        var limit = section ? (parseInt(section.dataset.limit, 10) || 8) : 8;
        var items = list.slice(0, limit);
        if (section) section.style.display = '';
        grid.innerHTML = items.map(function (p, i) {
          var bgs = ['#EDE5D8','#E4D9C8','#DDD0BC','#D6C8B0','#CFC2A4','#C8BB9A'];
          var bg = bgs[i % bgs.length];
          var img = p.image
            ? '<img src="' + p.image + '" alt="' + p.title + '" style="width:100%;height:100%;object-fit:cover;">'
            : '';
          return '<div class="col-prod-card"><a href="' + p.url + '" class="col-prod-img">' +
            '<div class="col-prod-img-inner prod-h" style="background:' + bg + ';">' + img + '</div>' +
            '</a><div class="col-prod-body"><p class="col-prod-type">Wall Art</p>' +
            '<a href="' + p.url + '"><h3 class="col-prod-name sm">' + p.title + '</h3></a>' +
            '<div class="col-prod-meta"><div class="col-prod-prices">' +
            '<span class="col-prod-price sm">' + p.price + '</span></div></div></div></div>';
        }).join('');
        if (typeof initQuickAdd === 'function') initQuickAdd();
      });
    } catch (e) {}
  }

  /* ── WISHLIST ─────────────────────────────────────────── */
  NexHome.toggleWishlist = function (e, id) {
    e.preventDefault();
    e.stopPropagation();
    try {
      var btn  = e.currentTarget;
      var list = JSON.parse(localStorage.getItem('nex_wishlist') || '[]');
      var data = JSON.parse(localStorage.getItem('nex_wishlist_data') || '{}');
      var idx  = list.indexOf(id);
      if (idx > -1) {
        list.splice(idx, 1);
        delete data[id];
      } else {
        list.push(id);
        // Save product details (from the button's data-* attributes) so the
        // wishlist page can render without any extra lookup.
        data[id] = {
          id: id,
          url: btn.dataset.wlUrl || '',
          title: btn.dataset.wlTitle || '',
          image: btn.dataset.wlImage || '',
          price: btn.dataset.wlPrice || '',
          compare: btn.dataset.wlCompare || ''
        };
      }
      localStorage.setItem('nex_wishlist', JSON.stringify(list));
      localStorage.setItem('nex_wishlist_data', JSON.stringify(data));
      btn.classList.toggle('active', list.includes(id));
      updateWishlistCount(list.length);
    } catch (err) {}
  };

  function updateWishlistCount(n) {
    var el = document.getElementById('wishlistCount');
    if (el) { el.textContent = n; el.style.display = n > 0 ? 'flex' : 'none'; }
  }

  function syncWishlistButtons() {
    try {
      var list = JSON.parse(localStorage.getItem('nex_wishlist') || '[]');
      qsa('[data-wishlist-id]').forEach(function (btn) {
        btn.classList.toggle('active', list.includes(btn.dataset.wishlistId));
      });
      updateWishlistCount(list.length);
    } catch (e) {}
  }
  // Exposed so the wishlist page can refresh header count + heart states
  // after removing an item.
  NexHome.syncWishlist = syncWishlistButtons;

  /* ── QUANTITY CONTROL ─────────────────────────────────── */
  function initQtyControls() {
    qsa('.qty-btn').forEach(function (btn) {
      on(btn, 'click', function () {
        var display = btn.closest('.qty-box').querySelector('.qty-num');
        var input   = btn.closest('form') && btn.closest('form').querySelector('input[name="quantity"]');
        if (!display) return;
        var val = parseInt(display.textContent, 10) || 1;
        if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
        else val = val + 1;
        display.textContent = val;
        if (input) input.value = val;
      });
    });
  }

  /* ── SIZE / VARIANT BUTTONS ───────────────────────────── */
  function initVariantButtons() {
    qsa('.variant-picker-buttons').forEach(function (picker) {
      var btns = qsa('.size-btn,.variant-btn,.finish-btn', picker);
      btns.forEach(function (btn) {
        on(btn, 'click', function () {
          btns.forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          var variantId = btn.dataset.variantId;
          var form = btn.closest('form');
          if (form && variantId) {
            var inp = form.querySelector('[name="id"]');
            if (inp) inp.value = variantId;
          }
        });
      });
    });
  }

  /* ── MOBILE FILTER SHEET ──────────────────────────────── */
  function initFilterSheet() {
    var overlay = qs('.filter-sheet-overlay');
    var sheet   = qs('.filter-sheet');
    function openSheet() {
      if (overlay) overlay.classList.add('open');
      if (sheet)   sheet.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeSheet() {
      if (overlay) overlay.classList.remove('open');
      if (sheet)   sheet.classList.remove('open');
      document.body.style.overflow = '';
    }
    qsa('[data-filter-open]').forEach(function (btn) { on(btn, 'click', openSheet); });
    qsa('.mob-filter-btn[data-filter-open]').forEach(function (btn) { on(btn, 'click', openSheet); });
    on(qs('.filter-sheet-head button'), 'click', closeSheet);
    on(qs('.btn-sheet-clear'), 'click', closeSheet);
    on(qs('.btn-sheet-apply'), 'click', closeSheet);
    on(overlay, 'click', function (e) { if (e.target === overlay) closeSheet(); });
  }

  /* ── GRID TOGGLE ──────────────────────────────────────── */
  function initGridToggle() {
    qsa('.grid-btn').forEach(function (btn) {
      on(btn, 'click', function () {
        var grid = qs('.col-prod-grid');
        if (!grid) return;
        qsa('.grid-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (btn.dataset.cols === '4') {
          grid.classList.add('four-col');
          qsa('.col-prod-img-inner', grid).forEach(function (el) { el.classList.add('four-col'); });
        } else {
          grid.classList.remove('four-col');
          qsa('.col-prod-img-inner', grid).forEach(function (el) { el.classList.remove('four-col'); });
        }
      });
    });
  }

  /* ── DIALOG MODALS (size guide, contact form) ─────────── */
  function initDialogs() {
    qsa('[data-dialog-open]').forEach(function (btn) {
      var targetId = btn.dataset.dialogOpen;
      var dialog = document.getElementById(targetId);
      on(btn, 'click', function () {
        if (dialog && dialog.showModal) dialog.showModal();
        else if (dialog) dialog.setAttribute('open', '');
      });
    });
    qsa('dialog').forEach(function (dialog) {
      on(dialog, 'click', function (e) {
        var rect = dialog.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right ||
            e.clientY < rect.top  || e.clientY > rect.bottom) {
          if (dialog.close) dialog.close();
          else dialog.removeAttribute('open');
        }
      });
      var closeBtn = dialog.querySelector('[data-dialog-close]');
      on(closeBtn, 'click', function () {
        if (dialog.close) dialog.close();
        else dialog.removeAttribute('open');
      });
    });
  }

  /* ── CART COUNT ───────────────────────────────────────── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('.cart-count,[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ── QUICK ADD FORM ───────────────────────────────────── */
  function initQuickAdd() {
    qsa('.card-quick-add-form').forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: data })
          .then(function (r) { return r.json(); })
          .then(function () {
            updateCartCount();
            var btn = form.querySelector('.btn-quickadd');
            if (btn) {
              var orig = btn.textContent;
              btn.textContent = 'Added!';
              setTimeout(function () { btn.textContent = orig; }, 1500);
            }
          })
          .catch(function () {});
      });
    });
  }

  /* ── STICKY HEADER SCROLL ─────────────────────────────── */
  function initStickyHeader() {
    var header = qs('nav') || qs('.site-header');
    if (!header) return;
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('scrolled', y > 40);
      lastY = y;
    }, { passive: true });
  }

  /* ── GALLERY THUMBS ───────────────────────────────────── */
  function initGalleryThumbs() {
    qsa('.gallery').forEach(function (gallery) {
      var mainImg = qs('.gallery-main img', gallery);
      var thumbs  = qsa('.pdp-thumb', gallery);
      thumbs.forEach(function (thumb) {
        on(thumb, 'click', function () {
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          if (mainImg && thumb.querySelector('img')) {
            mainImg.src = thumb.querySelector('img').src.replace('_72x90', '_800x');
          }
        });
      });
    });
  }

  /* ── SCROLLING TEXT SPEED ─────────────────────────────── */
  function initScrollingText() {
    qsa('.marquee-track').forEach(function (track) {
      var speed = track.dataset.speed;
      if (speed) track.style.animationDuration = speed + 's';
    });
  }

  /* ── INIT ─────────────────────────────────────────────── */
  /* ── SECTION SLIDERS ─────────────────────────────────── */
  function initNexSliders() {
    qsa('.nex-slider').forEach(function(slider) {
      var track = slider.querySelector('.nex-slider-track');
      var prev  = slider.querySelector('.nex-slider-prev');
      var next  = slider.querySelector('.nex-slider-next');
      if (!track) return;

      var desktopCols = parseInt(slider.dataset.cols) || 2;
      var trackGap = 12;

      function applyColWidths() {
        var cols = window.innerWidth <= 767 ? 2 : desktopCols;
        track.querySelectorAll(':scope > *').forEach(function(item) {
          item.style.flex = '0 0 calc(' + (100 / cols) + '% - ' + (trackGap * (cols - 1) / cols) + 'px)';
        });
      }
      applyColWidths();
      window.addEventListener('resize', applyColWidths);

      // Wrap track for overlay arrow positioning
      var trackWrap = document.createElement('div');
      trackWrap.className = 'nex-track-wrap';
      track.parentNode.insertBefore(trackWrap, track);
      trackWrap.appendChild(track);

      var autoplay = slider.dataset.autoplay === 'true';
      var speed    = (parseInt(slider.dataset.speed) || 4) * 1000;
      var timer;

      function scrollByPage(dir) {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (dir > 0 && track.scrollLeft >= maxScroll - 4) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
        }
      }

      function resetTimer() {
        clearInterval(timer);
        if (autoplay) timer = setInterval(function() { scrollByPage(1); }, speed);
      }

      if (prev) on(prev, 'click', function() { scrollByPage(-1); resetTimer(); });
      if (next) on(next, 'click', function() { scrollByPage(1);  resetTimer(); });

      // Overlay arrows on trackWrap
      ['prev','next'].forEach(function(dir){
        var btn = document.createElement('button');
        btn.className = 'slid-overlay-btn slid-overlay-' + dir;
        btn.innerHTML = dir === 'prev' ? '&#8249;' : '&#8250;';
        btn.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
        btn.addEventListener('click', function(){ scrollByPage(dir === 'prev' ? -1 : 1); resetTimer(); });
        trackWrap.appendChild(btn);
      });
      trackWrap.addEventListener('mouseenter', function(){ trackWrap.classList.add('show-arrows'); });
      trackWrap.addEventListener('mouseleave', function(){ trackWrap.classList.remove('show-arrows'); });
      var touchTimer;
      trackWrap.addEventListener('touchstart', function(){
        trackWrap.classList.add('show-arrows');
        clearTimeout(touchTimer);
        touchTimer = setTimeout(function(){ trackWrap.classList.remove('show-arrows'); }, 2500);
      }, {passive:true});

      resetTimer();

      on(track, 'touchstart', function() { clearInterval(timer); });
      on(track, 'touchend',   resetTimer);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCursor();
    initMobileMenu();
    initSearch();
    initAccordions();
    initFaq();
    initTabs();
    initSlideshow();
    initCountdowns();
    initQtyControls();
    initVariantButtons();
    initFilterSheet();
    initGridToggle();
    initDialogs();
    initQuickAdd();
    initStickyHeader();
    initGalleryThumbs();
    initScrollingText();
    renderRecentlyViewed();
    syncWishlistButtons();
    updateCartCount();
    initNexSliders();
  });

})();
